import { type PropsWithChildren } from 'react';

import {
  GAUGE_VERTICAL_DEFAULT_OFFSET,
  GAUGE_VERTICAL_SMALL_OFFSET,
} from '../constants.js';
import { useGaugeChartSizeContext } from '../hooks/useGaugeChartSizeContext.js';

export const GaugeRootSVG = ({ children }: PropsWithChildren) => {
  const dimensions = useGaugeChartSizeContext();
  const width = dimensions?.width ?? 0;
  const height = dimensions?.height ?? 0;
  const verticalOffset =
    height > width
      ? height * GAUGE_VERTICAL_SMALL_OFFSET
      : height * GAUGE_VERTICAL_DEFAULT_OFFSET;

  return (
    <svg
      width="100%"
      height="100%"
      viewBox={`0 0 ${width} ${height}`}
      style={{ display: 'block' }}
    >
      <g transform={`translate(${width / 2}, ${height / 2 + verticalOffset})`}>
        {children}
      </g>
    </svg>
  );
};
